module.exports = __webpack_public_path__ + "img/Hotel_Nikko.e17232ba.jpg";